<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <!-- ---------------------- 索引表格 ---------------------- -->
    <div class='global-panel' v-loading.body="loading.main">
      <div class="global-header">
        <div class="global-title">班级管理</div>
        <div class='global-tbar'>
          <el-upload class="upload-demo"
                     :action="'rest/clazz/uploadClazzFile' "
                     :on-progress="uploadProgress"
                     :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                     :on-remove="handleRemove" :file-list="fileList" :show-file-list='false'
                     list-type="picture">
            <el-button type="primary" size="small" icon="el-icon-upload2">上传excel</el-button>
          </el-upload>
          <el-button size="small" type="success"  @click="downloadAttachment()">下载模板</el-button>
          <el-button size="small" type="danger"  @click="addClazz()">新增</el-button>
          <el-input size="small" v-model="condition.clazzName" placeholder="班级名称"></el-input>
          <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
        </div>
      </div>
      <hr>
      <div class='global-body'>
        <div class="global-paging" v-show="paging.allNum > paging.everySize" >
          <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
        </div>
        <el-table :data="clazzList" border stripe style="width: 100%" size="mini" highlight-current-row >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="schoolArea" label="校区" sortable width="100"></el-table-column>
          <el-table-column prop="period" label="学段" width="100" sortable></el-table-column>
          <el-table-column prop="grade" label="年级" width="100" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="clazzName" label="班级名称" width="150" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="staffName" label="班主任" width="150" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="displayOrder" label="排序" width="100" sortable></el-table-column>
          <el-table-column prop="note" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button class="global-text-btn-success" size="mini" type="text" @click="showClazz(scope.row)" style="margin-left: 10px;">编辑</el-button>
              <el-button class="global-text-btn-danger" size="mini" type="text" @click="dropClazz(scope.row)" style="margin-left: 10px;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页  -->
        <div v-show="paging.allNum > paging.everySize" class="global-paging">
          <hr/>
          <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="visible.param" width="50%" v-loading="loading.param" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="serverForm"  :model="currentRecord" label-width="80px":rules="serverRules">
        <el-form-item label="校区" prop="schoolArea">
          <el-input v-model="currentRecord.schoolArea"></el-input>
        </el-form-item>
        <el-form-item label="学段" prop="period">
          <el-input v-model="currentRecord.period"></el-input>
        </el-form-item>
        <el-form-item label="年级" prop="grade">
          <el-input v-model="currentRecord.grade"></el-input>
        </el-form-item>
        <el-form-item label="班级名称" prop="clazzName">
          <el-input v-model="currentRecord.clazzName"></el-input>
        </el-form-item>
        <el-form-item label="班主任" prop="staffName">
          <el-select v-model="currentRecord.staffName" filterable placeholder="请选择" clearable>
            <el-option v-for="item in staffCombo" :key="item.key" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序" prop="displayOrder">
          <el-input v-model="currentRecord.displayOrder"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.param = false">取 消</el-button>
      <el-button type="primary" @click="saveClazz()">保 存</el-button>
    </span>
    </el-dialog>
  </div>

</template>

<script>

  export default {
    name: 'Clazz',
    data () {
      return {
        // 遮罩
        loading: {main: false, param: false},
        // 可见
        visible: {param: false},
        // 检索条件
        condition: {clazzName:null},
        // 数据
        clazzList: [],
        fileList:[],
        staffCombo:[],
        // 当前记录
        currentRecord: {},
        // 分页
        paging: {currPage: 1, everySize: 15, allNum: 0},
        // 校验规则
        serverRules: {
          schoolArea: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          period: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          grade: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          clazzName: [
            { required: true, message: '该项必填', trigger: 'change' }
          ]
        }
      }
    },

    /*
     * 初始化
     */
    mounted: function () {
      var vm = this;
      vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';
      vm.findByCondition();
      vm.findCombo();
    },

    methods: {
      findCombo: function () {
        var vm = this;
        // 请求后台
        vm.$http.get('rest/commonCombo/staff?blank=false').then(response => {
          // 更新数据
          vm.staffCombo = response.body;
        }, response => {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        });
      },
      /*
      * 查询所有
      */
      findByCondition: function (currentPage) {
        var vm = this;
        // 区分分页与查询
        if(currentPage){
          vm.paging.currPage = currentPage;
        } else {
          vm.paging.currPage = 1;
        }
        // 开启遮罩
        vm.loading.main = true;
        var params = vm.condition
        params.currPage = vm.paging.currPage
        params.everySize = vm.paging.everySize
        // 请求后台
        vm.$http.get('rest/clazz/findByCondition', {params: params}).then(response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 更新数据
          vm.clazzList = response.body.clazzList;
          vm.paging = response.body.pagingBean;
          // 提示
          vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
        }, response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      },
      addClazz: function () {
        var vm = this;
        vm.currentRecord = {id:null,schoolArea:null,period:null,grade:null,clazzName:null,displayOrder:null,note:null};
        vm.visible.param = true;
      },
      showClazz: function (record) {
        var vm = this;
        vm.currentRecord = JSON.parse(JSON.stringify(record));
        vm.visible.param = true;
      },
      dropClazz: function (record) {
        var vm = this;
        vm.$confirm('确定要【删除】班级[' + record.clazzName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
          // 开启遮罩
          vm.loading.main = true;
          // 请求后台
          vm.$http.post('rest/clazz/dropClazz', null, {params: {id:record.id}}).then(function (response) {
            // 关闭遮罩
            vm.loading.main = false;
            vm.findByCondition(vm.paging.currPage);
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.main = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        }).catch(() => {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
        });
      },
      saveClazz: function () {
        var vm = this;
        // 校验
        vm.$refs['serverForm'].validate((valid) => {
          if (!valid) {
            // 提示信息
            vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
            // 获取焦点
            vm.$nextTick(() => {
              vm.$refs['serverForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
            })
            return false;
          }
          // 开启遮罩
          vm.loading.param = true;
          // 请求后台
          vm.$http.post('rest/clazz/saveClazz', vm.currentRecord).then(function (response) {
            // 关闭遮罩
            vm.loading.param = false;
            // 关闭窗口
            vm.visible.param = false;
            // 刷新
            vm.findByCondition(vm.paging.currPage);
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.param = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        });
      },
      uploadProgress:function (event, file, fileList){
        var vm =this
        vm.loading.main = true;
      },
      uploadError:function (err, file, fileList){
        var vm =this
        vm.loading.main = false;
        // 弹出错误信息
        this.$alert(JSON.parse(err.message).message, '警告', {
          confirmButtonText: '确定',
          type: 'error'
        });
      },
      uploadSuccess:function (){
        var vm =this
        vm.loading.main = false;
        vm.$notify({position: 'bottom-right', type: 'success', message: '上传成功'});
        vm.findByCondition()
      },
      handlePreview:function (){

      },
      handleRemove:function (){
      },
      // 下载附件
      downloadAttachment: function (record) {
        var vm = this;
        // 开启遮罩
        vm.loading.main = true;
        let xhr = new XMLHttpRequest();
        xhr.open('POST', '/rest/clazz/download', true);
        xhr.responseType = 'arraybuffer';
        xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
        xhr.onreadystatechange = function (event) {
          if (this.readyState == 4 && this.status == 200) {
            // 关闭遮罩
            vm.loading.main = false;
            let contentDisposition = xhr.getResponseHeader('Content-Disposition');
            let index = contentDisposition.indexOf("attachment; filename=");
            let fileName = "未知文件"
            if (index >= 0) {
              fileName = contentDisposition.substring(index + 21);
            }
            //生成Blob对象，通过创建的a标签点击下载
            var objectUrl = URL.createObjectURL(new Blob([this.response]));
            var link = document.createElement("a");
            link.download = decodeURIComponent(fileName);
            link.href = objectUrl;
            link.click();
          } else if (this.readyState == 4 && this.status != 200) {
            // 关闭遮罩
            vm.loading.main = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
            vm.$baize.handle(vm, {status: this.status, body: this.response});
          }
        };
        xhr.send();
      }
    }
  }
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/app/Clazz.vue